import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import ShiftingCustomer from "../components/shiftingCustomer.jsx";
import Footer from "../components/footer.jsx";

function ShiftingCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <ShiftingCustomer/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default ShiftingCustomerpage;
